/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { InterpolationData } from '../../models/interpolation/interpolation-data.type';
import { interpolate } from '../../utils/interpolation/interpolation.utils';

@Pipe({
  name: 'appInterpolate',
  standalone: true,
})
export class InterpolatePipe implements PipeTransform {
  transform<T extends object>(value: T, data: InterpolationData): T;

  transform<T extends unknown[]>(value: T, data: InterpolationData): T;

  transform(value: number, data: InterpolationData): number;

  transform(value: boolean, data: InterpolationData): boolean;

  transform(value: string | null | undefined, data: InterpolationData): string;

  transform(value: any, data: InterpolationData): any {
    const interpolated = interpolate(value, data);

    if (interpolated === null || interpolated === undefined) {
      return '';
    }
    return interpolated;
  }
}
